import { render, staticRenderFns } from "./PMChartsTable.vue?vue&type=template&id=37492875&"
import script from "./PMChartsTable.vue?vue&type=script&lang=ts&"
export * from "./PMChartsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartsTable.vue?vue&type=style&index=0&id=37492875&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports